module.exports = __webpack_public_path__ + "img/2-7-caesars.e901c724.jpg";